import React, { FormEvent, useContext, useEffect, useState } from "react";
import { Grid, Segment, Form, Button, Popup, Dropdown, Table, Checkbox, Input, List, Image, Divider, Header, Icon, Menu, Select } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import TimeSheetPayStore from "../../../app/stores/timesheetpayStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { CSVLink } from 'react-csv';
import { ITimeSheet } from "../../../app/models/timesheet";
import { Link } from "react-router-dom";

const TimeSheetPayForm: React.FC = () => {
  const timesheetpayStore = useContext(TimeSheetPayStore);
  const {
    submitting,
    loadPayrollCycles,
    payrollcyclesByName,
    payrollcycleRegistry,
    loadTimeSheets,
    timesheetsByDate,
    editTimeSheets,
    loadEmployees,
    payrunstatusByDate,
    employeeByName,
    selectPayRun,
    selectEmployee,
    employeestatusRegistry,
    payrunweekRegistry,
    employeeRegistry,
    loadProjectTimes,
    projecttimeRegistry,
    payrunToCSV,
    employeeToCSV,
    clearPage,
  } = timesheetpayStore;

  useEffect(() => {
    loadPayrollCycles().then(() => loadEmployees()).then(() => loadProjectTimes()).then(
      ()=> loadTimeSheets()).then((pay)=>setSelectedPayrun(pay));

    return () => {
      clearPage();
    };
  }, []);

  const [selectedPayrun, setSelectedPayrun] = useState('');
  const [activeItem, setActiveItem] = useState('');

  if (timesheetpayStore.loadingInitial)
    return <LoadingComponent content="Loading time sheet..." />;
    
  const payrunstatusOptions = payrunstatusByDate.map(function (pay) {
    var option = { "key": pay.payRun, 
                  "text": <div> <strong>{pay.payRun}</strong>&nbsp;&nbsp;({pay.financeYear})</div>, 
                  "value": pay.financeYear + '-' + pay.payRun }
    return option;
  }
  );

  function getDayOfWeek(date: string) {
    const dayOfWeek = new Date(date).getDay();    
    return isNaN(dayOfWeek) ? null : 
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
  }

  function addDays(myDate: string, days: number) {
    return new Date(new Date(myDate).getTime() + days*24*60*60*1000).toISOString().substr(0, 10);
  }

  function convertDate(date: string) {
    var arrDate = date.split("-");
    return arrDate[2] + "/" +arrDate[1] + "/" + arrDate[0];
  } 

  function totalDays() {
    let total = 0;
    timesheetsByDate.map((time) => {
        total = total + Number(time.fullDay);                  
    });
    return total;
  };

  function totalWorkingHours() {
    let total = 0;
    timesheetsByDate.map((time) => {
        total = total + Number(time.workingHours);                  
    });
    return total;
  }; 

  function totalOvertimeHours() {
    let total = 0;
    timesheetsByDate.map((time) => {
        total = total + Number(time.overtimeHours);                  
    });
    return total;
  }; 

  function totalAdjustOvertimeHours() {
    let total = 0;
    timesheetsByDate.map((time) => {
      var rate = (projecttimeRegistry.get(time.projectType)) ? projecttimeRegistry.get(time.projectType).penaltyRate : 1
        total = total + (Number(time.overtimeHours) * Number(rate));                  
    });
    return total;
  }; 

  function totalWeekendHours() {
    let total = 0;
    timesheetsByDate.map((time) => {
        total = total + Number(time.weekendHours)+ Number(time.nightHours);                   
    });
    return total;
  }; 

  function totalAdjustWeekendHours() {
    let total = 0;
    timesheetsByDate.map((time) => {
      var weekendRate = (projecttimeRegistry.get(time.projectType)) ? projecttimeRegistry.get(time.projectType).weekendRate : 1
      var nightRate = (projecttimeRegistry.get(time.projectType)) ? projecttimeRegistry.get(time.projectType).nightRate : 1
        total = total + (Number(time.weekendHours) * Number(weekendRate)) + (Number(time.nightHours) * Number(nightRate));                  
    });
    return total;
  }; 

  return (
    <Segment clearing>
        <Grid>
          <Grid.Column width='4'>
          <Select 
            placeholder='Select Pay Run'
            options={payrunstatusOptions} 
            onChange={(e, {value}) => selectPayRun(String(value)).then(() => setSelectedPayrun(String(value)))} 
            value={selectedPayrun}
          />
          </Grid.Column>
          <Grid.Column width='6'>
          <List>
              <List.Item style={{color: 'gold', fontWeight: 'bold'}}> {payrollcycleRegistry.get(selectedPayrun) &&
                 'Week 1: \xa0\xa0\xa0\xa0\xa0\xa0' + 
                 convertDate(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10)) +
                 '\xa0\xa0 - \xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 6))}
              </List.Item>
              <List.Item style={{color: 'limegreen', fontWeight: 'bold'}}>
                 {payrollcycleRegistry.get(selectedPayrun) &&
                 'Week 2: \xa0\xa0\xa0\xa0\xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 7)) +
                 '\xa0\xa0 - \xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 13))}
              </List.Item>
            </List>
          </Grid.Column>
          <Grid.Column width='2'>
           <CSVLink data={payrunToCSV}  filename={selectedPayrun+".csv"}>
            <Popup content={'Download '+selectedPayrun} trigger={<Button icon='download' floated='left' />} />
           </CSVLink>
          </Grid.Column>
        </Grid>
        <br/>
        <List horizontal>  
        {employeeByName.map(emp => (     
              <List.Item >
               <Button compact 
                 onClick={() => selectEmployee(emp.email).then(() => setActiveItem(emp.name))}
                 style={{background: (activeItem === emp.name) ? 'lightgrey' : 'transparent',
                         border: 'solid 1px lightgrey',}}
               >
               <Image avatar src={emp.photoUrl || "/assets/user.png"}/>
                <strong style={{color: (employeestatusRegistry.get(emp.email) === 'Paid') ? 'green' : 'grey'}}>
                  {emp.name}{emp.preferredName !== "" ? `  (${emp.preferredName})` : ""}</strong>
                  &nbsp;&nbsp;-&nbsp;&nbsp;
                  <i style={{color: (employeestatusRegistry.get(emp.email) === 'Paid') ? 'green' : 'grey'}}>
                    {employeestatusRegistry.get(emp.email)}</i>
              </Button>
              </List.Item>
        ))}
        </List>
        <Divider horizontal >
      <Header as='h4'>
      <Icon name='arrow alternate circle down' />
      {timesheetsByDate.length !== 0 && 
      employeeRegistry.get(timesheetsByDate[0].employeeEmail).name +`'s time sheet`}
      </Header>
       </Divider>
        <Table celled compact='very' size='small'>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Date</Table.HeaderCell>
        <Table.HeaderCell>Project</Table.HeaderCell>
        <Table.HeaderCell>Day</Table.HeaderCell>
        <Table.HeaderCell >Site</Table.HeaderCell>
        <Table.HeaderCell >
          <div>Onsite</div>
          <div>Time</div>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <div>Offsite</div>
          <div>Time</div>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <div>Working</div>
          <div>Hours</div>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <div>Overtime</div>
          <div>Hours</div>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <div>Overtime</div>
          <div>Rate</div>
        </Table.HeaderCell>
        <Table.HeaderCell>
        <div>Night/</div>
                             <div>Weekend</div>
          <div>Hours</div>
        </Table.HeaderCell>
        <Table.HeaderCell>
        <div>Night/</div>
                             <div>Weekend</div>
          <div>Rate</div>
        </Table.HeaderCell>    
        <Table.HeaderCell >LAHFA</Table.HeaderCell>
        <Table.HeaderCell >Remark</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {timesheetsByDate.map((time, index) => {
      return (
      <Table.Row key={time.id}>
        <Table.Cell
        style={{backgroundColor: (payrunweekRegistry.get(time.attendanceDate) === 'week1')
           ? 'yellow' : 'lightgreen'}}
           width='1'>
          <strong >{convertDate(time.attendanceDate)}</strong>
          <div>{getDayOfWeek(time.attendanceDate)}</div>
        </Table.Cell>
        <Table.Cell>
          {time.projectType}
        </Table.Cell>
        <Table.Cell width='1'>
          {time.fullDay}
        </Table.Cell>
        <Table.Cell>
          {time.site}
        </Table.Cell>
        <Table.Cell width='1'>
          {time.onsiteTime}
        </Table.Cell>
        <Table.Cell width='1'>
          {time.offsiteTime}
        </Table.Cell>
        <Table.Cell width='1'>
          {time.workingHours}
        </Table.Cell>
        <Table.Cell width='1'>
          {time.overtimeHours}
        </Table.Cell>
        <Table.Cell width='1'>
          {(projecttimeRegistry.get(time.projectType)) && projecttimeRegistry.get(time.projectType).penaltyRate}
        </Table.Cell>
        <Table.Cell width='1'>
        {(getDayOfWeek(time.attendanceDate) === 'Saturday' || 
                  getDayOfWeek(time.attendanceDate) === 'Sunday') ? time.weekendHours : time.nightHours}
        </Table.Cell>
        <Table.Cell width='1'>
        {(getDayOfWeek(time.attendanceDate) === 'Saturday' || 
                  getDayOfWeek(time.attendanceDate) === 'Sunday') ?
                            (projecttimeRegistry.get(time.projectType)) && 
                              projecttimeRegistry.get(time.projectType).weekendRate :
                              (projecttimeRegistry.get(time.projectType)) && 
                              projecttimeRegistry.get(time.projectType).nightRate }
        </Table.Cell>
        <Table.Cell>
          {time.lahfa}
        </Table.Cell>
        <Table.Cell>
          {time.remark}
        </Table.Cell>
      </Table.Row>
    )})}
    </Table.Body>
    <Table.Footer>
        <Table.Row>
      <Table.HeaderCell><strong>Total:</strong>
      </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell><strong>{totalDays()}</strong>
         </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell><strong>{totalWorkingHours().toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell><strong>{totalOvertimeHours().toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell><strong>{totalAdjustOvertimeHours().toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell><strong>{totalWeekendHours().toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell><strong>{totalAdjustWeekendHours().toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
        <Table.Row>
      <Table.HeaderCell><strong>Total All:</strong>
      </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell><strong>{totalDays()}</strong> days
         </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell><strong>{totalWorkingHours().toFixed(2)}</strong> hours
          </Table.HeaderCell>
          <Table.HeaderCell  colSpan='4'>
             Time in lieu: <strong>{(totalAdjustOvertimeHours()+totalAdjustWeekendHours()).toFixed(2)}</strong> hours
          </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Footer>
  </Table>
  <CSVLink data={employeeToCSV}  filename={(timesheetsByDate.length !== 0) ? 
         employeeRegistry.get(timesheetsByDate[0].employeeEmail).name+".csv" : 'na.csv'}>
            <Popup content={(timesheetsByDate.length !== 0) ? 'Download ' +
      employeeRegistry.get(timesheetsByDate[0].employeeEmail).name +`'s time sheet` : 'Select employee to download'} 
      trigger={<Button icon='download' floated='left' />} />
           </CSVLink>
     <Button
          loading={submitting}
          floated='right'
          color='green'
          content='Pay'
          onClick={() => editTimeSheets(timesheetsByDate[0].payRun, timesheetsByDate[0].employeeEmail, 'Paid')}
          disabled={(timesheetsByDate.length === 0) || 
            (employeestatusRegistry.get(timesheetsByDate[0].employeeEmail) === 'Paid')}
     />
     
    </Segment>
  );
};

export default observer(TimeSheetPayForm);
